/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

export const backendBaseUrl = 'https://license-server-dev-a9044.appspot.com';

export const firebaseConfig = {
  apiKey: 'AIzaSyBzOzwBVHsLq6Wt_IIe6GeY6Gw1UkK7Lus',
  authDomain: 'license-server-dev-a9044.firebaseapp.com',
  databaseURL: 'https://license-server-dev-a9044.firebaseio.com',
  projectId: 'license-server-dev-a9044',
  storageBucket: 'license-server-dev-a9044.appspot.com',
  messagingSenderId: '604784574595'
};
